import React, { useEffect } from "react";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { FaUtensils, FaDollarSign } from "react-icons/fa";
import "./SuperAdminDashboard.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useState } from 'react';
import { Col, Row } from "reactstrap";
import { Doughnut } from 'react-chartjs-2';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import Layout from '../Layout';
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import { var_api,image_api } from '../../constant';

ChartJS.register(ArcElement, Tooltip, Legend);
const SuperAdminDashboard = () => {
  // const statsData = [
  //   { key: "TOTAL SHOPS", value: '14' },
  //   { key: "ACTIVE SHOPS", value: '8' },
  //   { key: "INACTIVE SHOPS", value: '4' },
  // ];
  
  const history = useHistory(); 
  const [ loading, setLoading ] = useState(false);
  const [tables, setTables] = useState([]);
  const [topSale, setTopSale] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0") // Get the current month as two-digit format
  );
  const [selectedMonthTopSale, setSelectedMonthTopSale] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0") // Get the current month as two-digit format
  );
  const [statsData, setStatsData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("SAtoken")
    if (token === null){
      history.push('/admin');
    }
  }, );
  useEffect(() => {
    fetchStats();
    fetchTopshopSale();
    fetchTopshopOrders();
  }, [selectedMonth, selectedMonthTopSale]);


  const fetchStats = async () => {
    setLoading(true);
    const token = localStorage.getItem('SAtoken');
  
    try {
      const response = await axios.get(
        `${var_api}shop-quick-stats-count/${selectedMonth}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const data = response.data.data;
      setTables(data);
      const formattedStats = [
        { key: "TOTAL SHOPS", value: data.shop_count },
        { key: "ACTIVE SHOPS", value: data.active_count },
        { key: "INACTIVE SHOPS", value: data.inactive_count },
      ];
      setStatsData(formattedStats);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchTopshopSale = async () => {
    setLoading(true);
    const token = localStorage.getItem('SAtoken');
  
    try {
      const response = await axios.get(
        `${var_api}top-sales/${selectedMonthTopSale}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      const data = response.data.data;
      setTopSale(data);
      // setTopSale({
      //   labels: data.map((item) => item.shop_name),
      //   datasets: [
      //     {
      //       data: data.map((item) => item.total_sales),
      //       backgroundColor: ['#e57373', '#ef5350', '#d32f2f'], // Ensure color array matches data size
      //     },
      //   ],
      // });
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchTopshopOrders = async () => {
    setLoading(true);
    const token = localStorage.getItem('SAtoken');
  
    try {
      const response = await axios.get(
        `${var_api}top-shops-orders/${formatDateToDDMMYYYY(selectedDate)}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      const data = response.data.data;
      
      const transformedData = data.map((shop) => ({
        shopName: shop.shop_name,
        orderCount: shop.order_count,
        custCount: shop.customer_count,
        normalCount : shop.normal_order_count,
        creditCount: shop.credit_order_count
      }));
  
      // setTableData(transformedData);
      setTopSale(transformedData);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const formatDateToDDMMYYYY = (date) => {
    const selectedDate = new Date(date);
    return `${String(selectedDate.getDate()).padStart(2, '0')}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${selectedDate.getFullYear()}`;
  };

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [startIndex, setStartIndex] = useState(0);
  const generateUpcomingDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push({
        day: date.toLocaleDateString('en-US', { weekday: 'short' }),
        date: date.getDate(),
        month: date.toLocaleDateString('en-US', { month: 'short' }),
        fullDate: date,
      });
    }
    return dates;
  };
  const upcomingDates = generateUpcomingDates();
  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handleNext = () => {
    if (startIndex + 7 < upcomingDates.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };
  const top3Customers = topSale
  .sort((a, b) => b.value - a.value)
  .slice(0, 3);
  const pieChartData = {
    labels: top3Customers.map((customer) => customer.shop_name),
    datasets: [
      {
        data: top3Customers.map((customer) => customer.total_sales),
        backgroundColor: [
            '#e57373',  // Light red
            '#ef5350',  // Medium red
            '#d32f2f',  // Dark red
          ],
      },
    ],
  };

  return (
    <><Layout>
    <div className="dashboard">
      <h4 className="mb-3">SUMMARY</h4>
    
      <div className="stats-container mb-2">
      <div className="order-header">
        <h4 style={{	fontWeight: "bold",marginBottom:"0px"}}>  <i class="bi bi-heart-pulse" style={{margin:"10px 5px"}}></i>Quick Stats</h4>          <span>
        <select
            className="form-select form-select-sm"
            aria-label=".form-select-sm example"
            style={{ width: "110px", height: "40px", border: "1px solid black" }}
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)} // Update selectedMonth on change
          >
            {months.map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
</span>
        </div>
       <div className="stats-container-flex mb-2">
  {statsData.map((stat, index) => (
    <div 
      key={index} 
      className={`stat-column-flex ${index !== statsData.length - 1 ? 'with-divider' : ''}`}
    >
      <div className="stat-column">
        <h4>{stat.key.charAt(0).toUpperCase() + stat.key.slice(1)}</h4>
        <h2>{stat.key === "sales" ? `$${stat.value.toLocaleString()}` : stat.value}</h2>
      </div>
    </div>
  ))}
</div>

    </div>

      {/* Upcoming Orders */}
      {/* <div style={{display:"flex",width:"100%",gap: "20px"}}> */}
      <Row>
        <Col lg="6" className="mb-3">
      <div className="orders-section">
   
        <div className="order-header">
        <h4 style={{	fontWeight: "bold"}}>  <i class="bi bi-shop" style={{marginRight:"5px"}}></i>TOP 3 SHOPS</h4>          <span>View all orders</span>
        </div>

        <div className="date-headersuperadmin">
          <button onClick={handlePrevious} disabled={startIndex === 0} className="nav-button"><i class="bi bi-chevron-left"></i></button>
          <div className="date-rowsuperadmin">
            {upcomingDates.slice(startIndex, startIndex + 7).map((dateObj, index) => (
              <div
                key={index}
                className={`date-columnsuperadmin ${selectedDate.toDateString() === dateObj.fullDate.toDateString() ? 'selected' : ''}`}
                onClick={() => handleDateSelect(dateObj.fullDate)}
              >
                <span className="day">{dateObj.day}</span>
                <span className="date">{dateObj.date}</span>
                <span className="month">{dateObj.month}</span>
              </div>
            ))}
          </div>
          <button onClick={handleNext} disabled={startIndex + 7 >= upcomingDates.length} className="nav-button"><i class="bi bi-chevron-right"></i></button>
        </div>
     
       <div class="table-container"  style={{height:"100%",overflowY:"auto",fontSize:"13px"}}>
  <table class="table table-sm">
    <thead>
      <tr>
        <th scope="col">  SHOP NAME</th>
        <th scope="col">ORDER COUNT</th>
        <th scope="col">CUST COUNT </th>
        <th scope="col">NORMAL COUNT</th>
        <th scope="col">CREDIT COUNT</th>
      </tr>
    </thead>
    <tbody>
    {topSale.map((order, index) => ( <tr key={index}>
        <td>{order.shopName }</td>
        <td>{order.orderCount}</td>
        <td>{order.custCount}</td>
        <td>{order.normalCount} </td>
        <td>{order.creditCount}</td>
      </tr>
        ))}
  
    </tbody>
  </table>
</div>

        {/* <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">First</th>
      <th scope="col">Last</th>
      <th scope="col">Handle</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Mark</td>
      <td>Otto</td>
      <td>@mdo</td>
      <td>@fat</td>

    </tr>
    <tr>
      <td>Jacob</td>
      <td>Thornton</td>
      <td>@fat</td>

      <td>@fat</td>
    </tr>
   
  </tbody>
</table> */}
    </div>
    </Col>
    <Col lg="6">
      <div className="orders-section mb-4" style={{ padding: '0px' }}>
        <div className="top-customers-container">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h4 style={{ marginTop: '10px' }}>
            <i class="bi bi-pie-chart-fill" style={{ margin: '10px 5px' }}></i>
              {/* <i className="bi bi-people-fill" ></i> */}
              Top SHOP SALES
            </h4>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

            <span>
            <select
                className="form-select form-select-sm"
                aria-label=".form-select-sm example"
                style={{
                  width: '110px',
                  height: '40px',
                  border: '1px solid black',
                }}
                value={selectedMonthTopSale} // Set the current month as the default value
                onChange={(e) => setSelectedMonthTopSale(e.target.value)} // Update state on selection
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </span>
            </div>
          </div>
          <hr className="mt-2 mb-2" />
          <div className="customer-pie-chart-container">
  {/* Labels Section */}
  <div className="chart-labels">
    {pieChartData.labels.map((label, index) => (
      <div key={index} className="chart-label">
        <span
          className="label-color-box"
          style={{ backgroundColor: pieChartData.datasets[0].backgroundColor[index] }}
        ></span>
        <span className="label-name">{label}</span>
      </div>
    ))}
  </div>

  {/* Pie Chart Section */}
  <div className="chart-wrapper">
    <div className="chart">
    <Pie data={pieChartData} options={{ maintainAspectRatio: false, plugins: { legend: { display: false } } }} />
    </div>
  </div>
</div>

        </div>
      </div>
    </Col>
      </Row>
      {/* <Row>
        <Col lg="6">
      <div className="orders-section" style={{padding:"0px"}}>
      <div className="top-customers-container">
        <div style={{display:"flex",justifyContent:"space-between"}}>
      <h4 style={{    marginTop: "10px"}}><i class="bi bi-people-fill"  style={{margin:"10px 5px"}}></i>Top Customers</h4>
     
            <span><select class="form-select form-select-sm" aria-label=".form-select-sm example" style={{width:"110px",height:"40px",border:"1px solid black"}}>
  <option selected>This month</option>
  {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>    ))}
</select>
</span>
</div>
      <hr className="mt-2 mb-2"></hr>
      <ul className="customer-list">
        {customers.map((customer, index) => (
        
          <li key={index} className="customer-item">
              <Col lg="3" style={{textAlign:"end",marginRight:"10px"}}>
            <span className="customer-name">{customer.name}</span></Col>
            <Col lg="6">
            <div
              className="customer-bar"
              style={{
                width: `${(customer.value / maxValue) * 100}%`
              }}
            ></div>
            </Col>
          </li>
        ))}
      </ul>
    </div>
    </div>
    </Col>
    <Col lg="6">
      <div className="orders-section" style={{ padding: '0px' }}>
        <div className="top-customers-container">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h4 style={{ marginTop: '10px' }}>
              <i className="bi bi-people-fill" style={{ margin: '10px 5px' }}></i>
              Top Credit Customers
            </h4>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

            <span>
              <select
                className="form-select form-select-sm"
                aria-label=".form-select-sm example"
                style={{
                  width: '110px',
                  height: '40px',
                  border: '1px solid black',
                }}
              >
                <option selected>This month</option>
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </span>
            </div>
          </div>
          <hr className="mt-2 mb-2" />
          <div className="customer-pie-chart-container">
  <div className="chart-labels">
    {pieChartData.labels.map((label, index) => (
      <div key={index} className="chart-label">
        <span
          className="label-color-box"
          style={{ backgroundColor: pieChartData.datasets[0].backgroundColor[index] }}
        ></span>
        <span className="label-name">{label}</span>
      </div>
    ))}
  </div>

  <div className="chart-wrapper">
    <div className="chart">
    <Pie data={pieChartData} options={{ maintainAspectRatio: false, plugins: { legend: { display: false } } }} />
    </div>
  </div>
</div>

        </div>
      </div>
    </Col>
    </Row> */}
    
    </div>
    </Layout></>
  );
};

export default SuperAdminDashboard;
